export const getActualImageType = async (file: File): Promise<string | null> => {
    const CHUNK_SIZE = 12;
    try {
        const slice = file.slice(0, CHUNK_SIZE);
        const buffer = await slice.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        
        // JPEG file signature: FF D8
        if (bytes.length >= 2 && bytes[0] === 0xFF && bytes[1] === 0xD8) {
            return 'image/jpeg';
        }
        
        // PNG file signature: 89 50 4E 47 0D 0A 1A 0A
        if (bytes.length >= 8 && 
            bytes[0] === 0x89 && bytes[1] === 0x50 && 
            bytes[2] === 0x4E && bytes[3] === 0x47 &&
            bytes[4] === 0x0D && bytes[5] === 0x0A &&
            bytes[6] === 0x1A && bytes[7] === 0x0A) {
            return 'image/png';
        }
        
        // GIF file signature: 47 49 46 38 (GIF8)
        if (bytes.length >= 4 && 
            bytes[0] === 0x47 && bytes[1] === 0x49 && 
            bytes[2] === 0x46 && bytes[3] === 0x38) {
            return 'image/gif';
        }
        
        // WebP file signature: 52 49 46 46 ... 57 45 42 50 (RIFF....WEBP)
        if (bytes.length >= 12 &&
            bytes[0] === 0x52 && bytes[1] === 0x49 && 
            bytes[2] === 0x46 && bytes[3] === 0x46 &&
            bytes[8] === 0x57 && bytes[9] === 0x45 &&
            bytes[10] === 0x42 && bytes[11] === 0x50) {
            return 'image/webp';
        }
        
        // HEIC/HEIF file signature: Check ftyp box (at offset 4-11)
        if (bytes.length >= 12) {
            const ftypString = String.fromCharCode(...Array.from(bytes.slice(4, 8)));
            if (ftypString === 'ftyp') {
                const brandString = String.fromCharCode(...Array.from(bytes.slice(8, 12)));
                // Check various HEIC/HEIF brand identifiers
                if (brandString === 'heic' || brandString === 'heix' || 
                    brandString === 'hevc' || brandString === 'hevx' ||
                    brandString === 'mif1' || brandString === 'msf1') {
                    return 'image/heic';
                }
            }
        }
        
        return 'unknown';
    } catch (error) {
        console.error('Failed to read file header:', error);
        return null;
    }
};
